import { NgModule } from '@angular/core';
import { CompanySummaryScreenComponent } from './company-summary.screen.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '../../components/components.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';

@NgModule({
  declarations: [CompanySummaryScreenComponent],
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    MatTableModule,
    MatPaginatorModule,
    TranslateModule,
    ComponentsModule,
    ReactiveFormsModule,
    RouterModule.forChild([
      {
        path: '',
        component: CompanySummaryScreenComponent,
      },
    ]),
  ],
})
export class CompanySummaryScreenModule {}
